module.exports = __webpack_public_path__ + "img/receivables.e916b457.png";